import bus from '../utils/bus';

export default {
  methods: {
    showError(error) {
      if (error.response) {
        const message = error.response.data.message || error.message;
        this.$dialog.alert(message);
      }
    },
  },
  created() {
    bus.$on('response:error', this.showError);
  },
};
